import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import packages from '../data/packages.json';
import PackageDetail from '../components/packageDetail/PackageDetail';
import PageSEO from '../components/PageSEO';

const PackagePage = () => {
  const { slug } = useParams();
  const { pathname } = useLocation();
  const selectedPackage = packages.find(pkg => pkg.slug === slug);

  if (!selectedPackage) {
    return <div style={{ padding: '2rem' }}><h2>Package not found</h2></div>;
  }

  const levelStr = selectedPackage.level && selectedPackage.level !== 'undefined'
    ? ` — ${selectedPackage.level}` : '';
  const pkgDesc = selectedPackage.description
    ? selectedPackage.description.length > 160
      ? selectedPackage.description.slice(0, 157) + '…'
      : selectedPackage.description
    : '';

  return (
    <main className="section">
      <PageSEO
        title={`${selectedPackage.name}${levelStr} | PixelCraft`}
        description={pkgDesc}
        path={pathname}
      />
      <div className="container">
        <PackageDetail data={selectedPackage} />
        <div className="btn__wrapper">
          <button
            onClick={() => window.history.back()}
            className="button"
          >
            Back
          </button>
          <a href="/contacts" className="button">
            Get in touch
          </a>
        </div>
      </div>
    </main>
  );
};

export default PackagePage;
